import { createJourneyRouter } from '@cash-web/shared-journey-feature-main'

import { activityJourneyRoutes } from './lib/activity/routes'
import { bitcoinJourneyRoutes } from './lib/bitcoin/routes'
import { cardJourneyRoutes } from './lib/card/routes'
import { cashJourneyRoutes } from './lib/cash/routes'
import { cashtagJourneyRoutes } from './lib/cashtag/routes'
import { devicesJourneyRoutes } from './lib/devices/routes'
import { errorJourneyRoutes } from './lib/error/routes'
import { flowJourneyRoutes } from './lib/flow/routes'
import { investingJourneyRoutes } from './lib/investing/routes'
import { paychecksJourneyRoutes } from './lib/paychecks/routes'
import { poolsJourneyRoutes } from './lib/pools/routes'
import { savingsJourneyRoutes } from './lib/savings/routes'
import { settingsJourneyRoutes } from './lib/settings/routes'
import { stocksJourneyRoutes } from './lib/stocks/routes'
import { mergeJourneyRoutes } from './lib/utils/mergeJourneyRoutes'

export const rawJourneyRoutes = [
  ...errorJourneyRoutes,
  ...activityJourneyRoutes,
  ...bitcoinJourneyRoutes,
  ...cardJourneyRoutes,
  ...cashJourneyRoutes,
  ...devicesJourneyRoutes,
  ...savingsJourneyRoutes,
  ...investingJourneyRoutes,
  ...settingsJourneyRoutes,
  ...paychecksJourneyRoutes,
  ...poolsJourneyRoutes,
  ...stocksJourneyRoutes,
  ...flowJourneyRoutes,
  ...cashtagJourneyRoutes,
]

export const journeyRoutes = mergeJourneyRoutes(rawJourneyRoutes)

export const journeyRouter = createJourneyRouter(journeyRoutes)
